import { GREEN_DAY, WHITE } from '@bowtie-ins/bowkit/palette';
import { Box, Theme } from '@material-ui/core';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import { FormattedMessage } from 'react-intl';

const bounce = keyframes`
  0%, 13.33%, 33.33%, 53.33%, 66.67% {
    transform: translateY(0);
  }
  26.67% {
    transform: translateY(-4px);
  }
  40% {
    transform: translateY(-2px);
  }
  66.67%, 100% {
    transform: translateY(0);
  }
`;

const SaveCouponTooltipBox = styled('div')<{
  theme?: Theme;
  isVisible?: boolean;
}>(({ theme, isVisible = true }) => ({
  position: 'absolute',
  top: theme.spacing(-3),
  right: 0,
  backgroundColor: GREEN_DAY,
  color: WHITE,
  fontSize: 10,
  fontWeight: 'bold',
  padding: `0 ${theme.spacing(1)}px`,
  borderRadius: theme.spacing(3),
  whiteSpace: 'nowrap',
  zIndex: theme.zIndex.modal,
  opacity: isVisible ? 1 : 0,
  animation: isVisible ? `${bounce} 3s infinite` : 'none',
  transition: 'opacity 0.3s ease-out',
  '&::after': {
    content: `""`,
    position: 'absolute',
    top: '100%',
    right: theme.spacing(2.5),
    width: 0,
    height: 0,
    borderLeft: `${theme.spacing(1)}px solid transparent`,
    borderRight: `${theme.spacing(1)}px solid transparent`,
    borderTop: `${theme.spacing(1)}px solid ${GREEN_DAY}`,
  },
}));

interface SaveCouponTooltipProps {
  children: React.ReactNode;
  isVisible?: boolean;
}

const SaveCouponTooltip = ({
  children,
  isVisible = true,
}: SaveCouponTooltipProps) => (
  <Box position="relative">
    {children}
    <SaveCouponTooltipBox isVisible={isVisible}>
      <FormattedMessage id="coupon.save_tooltip" />
    </SaveCouponTooltipBox>
  </Box>
);

export default SaveCouponTooltip;
